import { SurveyActions } from '@r1-frontend/survey/context/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

const closePopup = (): IAction<SurveyActions.ClosePopup, null> => ({
    type: SurveyActions.ClosePopup,
    payload: null,
});

export default closePopup;
